export const dataURLToBlob = (dataURL: string): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    const xml = new XMLHttpRequest()
    xml.onload = function () {
      resolve(this.response)
    }
    xml.onerror = function () {
      reject(this.responseText)
    }
    xml.responseType = 'blob'
    xml.open('GET', dataURL)
    xml.send()
  })
}

export const downloadImage = (imageBase64: string) => {
  const a = document.createElement('a') // Create <a>
  a.href = imageBase64 // Image Base64 Goes here
  a.download = 'screenshot.png' // File name Here
  a.click() // Downloaded file
  a.remove()
}
